<script>
  import { onMount } from "svelte";
  import Conexoes from "../Classes/Conexoes";
  import { Accordion, Title } from "@svelteuidev/core";
  import Loading from "../componentes_basicos/Loading.svelte";
  import CaixaDeDialogo from "../componentes_basicos/CaixaDeDialogo.svelte";
  import Constantes from "../Classes/Constantes";
  let tasks = [];
  let conexoes = new Conexoes(Constantes.url_base_nutri);
  let timers = {};
  let carregando = false;
  let message = "";
  let habilitado = [];
  let idApagar = 0;
  let vermelho = false;
  let cor = "white";
  let newTask = {
    title: "",
    description: "",
    due_date: ""
  };

  async function loadTasks() {
    vermelho = false;
    let res = await conexoes.conecta("list_tasks.php", {});
    tasks = res.data;
  }

  async function addTask() {
    if (!newTask.title.trim()) return;
    await conexoes.conecta("add_task.php", newTask);
    console.log(cor);
    newTask = { title: "", description: "", due_date: "" };
    await loadTasks();
  }

  async function toggleCompleted(id) {
    await conexoes.conecta("toggle_task.php", { id });
    message = "";
    await loadTasks();
  }

  async function deleteTask(id) {
    idApagar = id;
    message = Constantes.msg_confirma_apagar_dados;
  }

  async function ConfirmaApagar() {
    console.log("id apagar", idApagar);
    await conexoes.conecta("delete_task.php", { id: idApagar });
    message = "";
    await loadTasks();
  }
  function reorderTasks() {
    tasks.forEach(async (t, index) => {
      await conexoes.conecta("reorder_task.php", { id: t.id, position: index });
    });
  }

  function moveUp(index) {
    if (index === 0) return;
    [tasks[index - 1], tasks[index]] = [tasks[index], tasks[index - 1]];
    reorderTasks();
  }

  function moveDown(index) {
    if (index === tasks.length - 1) return;
    [tasks[index + 1], tasks[index]] = [tasks[index], tasks[index + 1]];
    reorderTasks();
  }

  function scheduleUpdate(task) {
    if (timers[task.id]) clearTimeout(timers[task.id]);
    carregando = true;
    timers[task.id] = setTimeout(async () => {
      await conexoes.conecta("update_task.php", {
        id: task.id,
        title: task.title
      });
      carregando = false;
    }, 500);
  }

  async function updateColor(task, color) {
    task.color = color;
    await conexoes.conecta("update_task.php", { id: task.id, color });
    loadTasks();
  }
  async function AddColor(color) {
    console.log(color);
    cor = color;
  }

  onMount(() => loadTasks());

  function Habilita(i) {
    habilitado[i] = true;
    vermelho = true;
  }
</script>

<style>
  .tasks {
    max-width: 500px;
    margin: 20px auto;
    background: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    border-bottom: 1px solid #ddd;
    border-radius: 6px;
  }
  .circle {
    width: 20px;
    height: 20px;
    border: 2px solid #666;
    border-radius: 50%;
    margin-right: 10px;
    cursor: pointer;
  }
  .circle.completed {
    background: #4caf50;
  }
  .title-input {
    flex: 1;
    border: none;
    background: transparent;
    font-size: 16px;
    outline: none;
  }
  .completed-text {
    text-decoration: line-through;
    color: #888;
  }
  .actions {
    display: flex;
    gap: 2px; /* diminui o espaçamento entre eles */
    align-items: center;
  }

  .actions button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 12px; /* diminui o tamanho do ícone/texto */
    padding: 2px; /* bem compacto */
  }

  .actions button.delete {
    color: red;
  }

  .actions button.updown {
    color: #333;
  }

  .actions .color-picker {
    width: 18px; /* menor que 24px */
    height: 18px;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
  }
  button.delete {
    color: red;
  }
  button.updown {
    color: #333;
  }
  .color-picker {
    width: 24px;
    height: 24px;
    border: none;
    cursor: pointer;
    background: transparent;
    padding: 0;
  }
  .add {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
    gap: 10px;
  }
  .add input {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  .add button {
    padding: 8px 12px;
    background: #4caf50;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    align-self: flex-start;
  }
  .red {
    color: red;
  }
  .black {
    color: black;
  }
</style>

<div class="tasks">
  <h2>Tarefas de Momolinda</h2>
  <div class="add">
    <input type="text" placeholder="Tarefa" bind:value={newTask.title} />
    <!--<input type="color" class="color-picker" value={cor || '#ffffff'} on:change={(e) => AddColor(e.target.value)} />
   -->

    <button class="btn btn-success d-block w-100" on:click={addTask}>Adicionar tarefa</button>
  </div>
  <br />
  <Accordion
    multiple
    defaultValue={'A fazer'}
    chevronPosition="left"
    variant="separated">
    <Accordion.Item value={'A fazer'}>
      <div slot="control">
        <Title order={4} color="#3659fc">A fazer</Title>
      </div>

      {#each tasks as t, i}
        {#if t.completed != 1}
          <div class="item" style="background:{t.color || 'white'};">
            <div style="display:flex; align-items:center;">
              <div
                class="circle {t.completed == 1 ? 'completed' : ''}"
                on:click={() => toggleCompleted(t.id)} />
              {#if !habilitado[i]}
                <div
                  on:click={() => Habilita(i)}
                  class="title-input {t.completed == 1 ? 'completed-text' : ''}">
                  {t.title}
                </div>
              {:else}
                <input
                  class="{vermelho ? 'red' : 'black'} title-input {t.completed == 1 ? 'completed-text' : ''}"
                  type="text"
                  bind:value={t.title}
                  on:input={() => scheduleUpdate(t)} />
              {/if}
            </div>
            <div class="actions">
              <input
                type="color"
                class="color-picker"
                value={t.color || '#ffffff'}
                on:change={e => updateColor(t, e.target.value)} />
              <button class="updown" on:click={() => moveUp(i)}>⬆️</button>
              <button class="updown" on:click={() => moveDown(i)}>⬇️</button>
              <button class="delete" on:click={() => deleteTask(t.id)}>
                🗑️
              </button>
              <Loading {carregando} />
            </div>
          </div>
        {/if}
      {/each}
    </Accordion.Item>

    <Accordion.Item value={'Feito'}>
      <div slot="control">
        <Title order={4} color="#3659fc">Feito</Title>
      </div>

      {#each tasks as t, i}
        {#if t.completed == 1}
          <div class="item" style="background:{t.color || 'white'};">
            <div style="display:flex; align-items:center;">
              <div
                class="circle {t.completed == 1 ? 'completed' : ''}"
                on:click={() => toggleCompleted(t.id)} />
              {#if !habilitado[i]}
                <div
                  class="title-input {t.completed == 1 ? 'completed-text' : ''}">
                  {t.title}
                </div>
              {:else}
                <input
                  class="{vermelho ? 'red' : 'black'} title-input {t.completed == 1 ? 'completed-text' : ''}"
                  type="text"
                  bind:value={t.title}
                  on:input={() => scheduleUpdate(t)} />
              {/if}
            </div>
            <div class="actions">
              <input
                type="color"
                class="color-picker"
                value={t.color || '#ffffff'}
                on:change={e => updateColor(t, e.target.value)} />
              <button class="updown" on:click={() => moveUp(i)}>⬆️</button>
              <button class="updown" on:click={() => moveDown(i)}>⬇️</button>
              <button class="delete" on:click={() => deleteTask(t.id)}>
                🗑️
              </button>
              <Loading {carregando} />
            </div>
          </div>
        {/if}
      {/each}
    </Accordion.Item>
  </Accordion>
</div>
<CaixaDeDialogo
  {message}
  on:close={() => {
    message = '';
  }}
  button1Label={'Cancelar'}
  button2Label={'Apagar'}
  button2Action={() => ConfirmaApagar()} />
